import 'core-js/fn/object/assign';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './Main';
import {BrowserRouter} from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {Provider} from 'mobx-react';
import userStore from 'stores/userStore';
import sideBarStore from 'stores/sidebarStore';
import headerStore from 'stores/headerStore';
import videoPopUpStore from 'stores/videoPopUpStore';
import alertStore from 'stores/AlertStore';
import preloaderStore from 'stores/PreloaderStore';
import editableCategoryStore from 'stores/EditableCategoryStore';
import categoryStore from 'stores/CategoryStore';
import vimeoVideo from 'stores/VimeoVideo';
import createTutorialStore from 'stores/CreateTutorialStore';
import createCourseStore from 'stores/CreateCourseStore';
import courseStore from 'stores/CourseStore';
import topicsStore from 'stores/TopicsStore';
import examPrepHeaderStore from 'stores/examPrepHeader';
import resourcesStore from 'stores/ResourcesStore';
import 'styles';


const stores = {
  userStore,
  sideBarStore,
  headerStore,
  videoPopUpStore,
  alertStore,
  preloaderStore,
  editableCategoryStore,
  categoryStore,
  vimeoVideo,
  createTutorialStore,
  createCourseStore,
  courseStore,
  topicsStore,
  examPrepHeaderStore,
  resourcesStore,
};
ReactDOM.render(
  <BrowserRouter>
    <Provider {...stores}>
      <MuiThemeProvider>
          <App/>
      </MuiThemeProvider>
    </Provider>
  </BrowserRouter>,
  document.getElementById('app'));






// WEBPACK FOOTER //
// ./src/index.js